module.exports = __webpack_public_path__ + "static/img/5.3aa86d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = PgLh
// module chunks = 1